import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../login/AuthProvider";
import axios from "axios";
import { backend } from '../../../components/apipath';

const Form = () => {
    const { setAuth } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const account = document.getElementById('account')?.value.trim();
        const password = document.getElementById('password')?.value.trim();

        if (!account || !password) {
            document.getElementById("error").innerText = "請輸入帳號與密碼";
            return;
        }

        try {
            // 🔐 登入 API：建立 session
            await axios.post(`${backend}login/employee`, {
                account,
                password
            }, {
                withCredentials: true
            });

            // ✅ 登入成功後：向後端確認 session 狀態
            const res = await axios.get(`${backend}login/checkAuth`, {
                withCredentials: true
            });

            if (res.data?.authorized && (res.data.type === 'admin' || res.data.type === 'teacher')) {
                setAuth({
                    ...res.data,
                    authorized: true
                });

                // 🔁 若網址帶有 redirect，登入後跳回原頁；否則進入後台首頁
                const params = new URLSearchParams(location.search);
                const redirect = params.get("redirect") || "/adm/admh";
                navigate(redirect);
            } else {
                document.getElementById("error").innerText = "您無後台權限";
            }
        } catch (err) {
            console.error(err);
            document.getElementById("error").innerText =
                err?.response?.data?.errors || "登入失敗，請確認帳號與密碼";
        }
    };

    return (
        <form id="form" onSubmit={handleSubmit}>
            <h2 className='mb-5'>Direct Line 後台登入</h2>

            <div>
                <label htmlFor="account">帳號</label>
                <input className='form-control' type="email" id="account" name="account" required />
            </div>

            <div>
                <label className='mt-5' htmlFor="password">密碼</label>
                <input className='form-control' type="password" id="password" name="password" required />
            </div>

            <div id="error" className="text-danger mt-3"></div>

            <input className='btn btn-primary mt-5' type="submit" value="登入" />
        </form>
    );
};

export default Form;
